/* eslint-disable @typescript-eslint/no-empty-function */
/**
 * 重复接口调用缓存处理 */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
import { UniRequest } from '@uniframe/toolkit';
import Cookie from 'js-cookie';

import {
  API2_HOST,
  BYBIT_LANG_KEY,
  BYBIT_TOKEN_COOKIE_KEY,
} from '@/utils/constants';
import { getGuid } from '@/utils/guid';
import { isMobile } from '@/utils/ua';
// platform

export const platform = isMobile() ? 'h5' : 'pc';

const _global = window as any;

//todo: 增加toolkit.d.ts
const request: any = new UniRequest({ responseType: 'json' });
interface IRequestOption<T> {
  headers?: {};
  method?:
    | 'GET'
    | 'POST'
    | 'PUT'
    | 'DELETE'
    | 'get'
    | 'post'
    | 'put'
    | 'delete';
  body?: any;
  responseType?: (typeof validResponseType)[number];
  errorHandler?: (response: Response) => void;
  hideError?: boolean;
  flag?: string;
  ttl?: number;
}

class ByError extends Error {
  data: {
    ret_code: number | string;
    ret_msg: string;
  } | null = null;
}

// 默认长时间缓存接口
const cacheLongTimeFetchList = [
  '/v2/private/user/profile',
  '/user/private/member/info',
  '/register/permission_v2',
  '/user/private/profile-v2',
  '/compliance/v1/wall/regulation-info',
];

const matchLongTimeFetch = (url: string) => {
  const _url = url.replace(API2_HOST, '');

  if (cacheLongTimeFetchList.includes(_url)) {
    return true;
  }
  return false;
};

const validResponseType = [
  'text',
  'json',
  'blob',
  'arrayBuffer',
  'formData',
] as const;

const defaultErrorHandler = () => {};
const defaultOption = {
  'Content-Type': 'application/json;charset=UTF-8',
  Accept: 'application/json',
};
const fetchData = <T>(
  url: string,
  options: IRequestOption<T> = { headers: {} },
): Promise<T> => {
  let fetchUrl = url;

  // if()

  // 非指定接口，缓存3s，默认缓存60s
  if (!matchLongTimeFetch(url) && !options.ttl) {
    options.ttl = 3 * 1000;
  }

  if (options.body && (!options.method || options.method === 'GET')) {
    const bodyData = JSON.parse(options.body);
    const queryParams = Object.keys(bodyData).map(
      (key) => `${key}=${encodeURIComponent(bodyData[key])}`,
    );

    fetchUrl = `${url}?${queryParams.join('&')}`;

    delete options.body;
  }

  let userToken: string | null | undefined = Cookie.get(BYBIT_TOKEN_COOKIE_KEY);
  let guid;
  let lang: string;

  guid = getGuid();

  lang = window.localStorage.getItem(BYBIT_LANG_KEY) || 'en';

  const mergedOptions = {
    credentials: 'include',
    ...options,
    headers: {
      ...defaultOption,
      platform,
      ...options.headers,
      UserToken: (userToken === 'null' ? '' : userToken) || '',
      Guid: guid,
      Lang: lang === 'en-US' ? 'en' : lang,
    },
  };

  const start = performance.now();
  return new Promise((resolve, reject) => {
    // if (mergedOptions.flag === 'formData') delete mergedOptions.headers['Content-Type'];
    const method = mergedOptions.method?.toLowerCase() ?? 'get';

    let _options = JSON.parse(JSON.stringify(mergedOptions));

    request[method](fetchUrl, _options)
      .then((resp: any) => {
        const { errorHandler } = options;
        if (resp.status >= 400) {
          const handler = errorHandler || defaultErrorHandler;
          handler(resp);
          return null;
        }
        return resp;
      })
      .then(({ data, response }: any) => {
        const { ret_code, ret_msg, token, result } = data || {};
        //兼容signup 首页/fht/growth/activity-api/v1/korea/home接口返回
        if (ret_code === 0 || data.retCode === 0) {
          resolve({
            ...data,
            headers: response?.headers,
            currentSite: response?.headers.get('x-refer-site-id'),
          });
          return;
        }
        const time = performance.now() - start;

        if (data.ret_code !== 0 || data.retCode !== 0) {
          reject({ ...data });
        }

        // if (!(ret_code === undefined) && ret_code !== 0 && ret_code !== 10007) {
        //   if (
        //     fetchUrl.indexOf('unbind-google-2fa/send-code-to-email') >= 0 &&
        //     ret_code === 20035
        //   ) {
        //     const error = new ByError('Response Error');
        //     error.data = { ret_code: 35300, ret_msg };
        //     throw error;
        //   } else if (fetchUrl.indexOf('login') > -1 && ret_code === 31002) {
        //     if (
        //       result.pass_err_count &&
        //       (result.pass_err_count === 3 ||
        //         result.pass_err_count === 4 ||
        //         result.pass_err_count === 5)
        //     ) {
        //       resolve(data);
        //     } else {
        //       const error = new ByError(ret_msg);
        //       error.data = { ret_code, ret_msg };
        //       throw error;
        //     }
        //   } else {
        //     const error = new ByError(ret_msg);
        //     error.data = { ret_code, ret_msg };
        //     throw error;
        //   }
        // }
        // resolve({
        //   ...data,
        //   headers: response?.headers,
        //   currentSite: response?.headers.get('x-refer-site-id'),
        // });
      })
      .catch((e: any) => {
        const time = performance.now() - start;
        if (e?.response?.status === 403) {
          console.log('error403', url, time);
          //   track('result403', {
          //     route: url,
          //     time_consuming: time,
          //     failure_reason: 'return 403',
          //   });
          // addEvent({
          //   c: 80403,
          //   m: "registerLogin: 403",
          //   ext: {
          //     t: "error",
          //     hc: 403,
          //     href: _global.location.href,
          //   },
          //   r: url,
          //   t: "ajax",
          //   d: time,
          // });
        }

        if (!e || !e?.data) {
          //   track('resultError200', {
          //     route: url,
          //     time_consuming: time,
          //     failure_reason: '-200 cors',
          //   });
          //   // addEvent({
          //   //   c: 80403,
          //   //   m: "registerLoginCors: 403",
          //   //   ext: {
          //   //     t: "error",
          //   //     hc: 403,
          //   //     href: _global.location.href,
          //   //   },
          //   //   r: url,
          //   //   t: "ajax",
          //   //   d: time,
          //   // });
          reject({ ret_code: -200, ret_msg: e, poz: 2 });
          return;
        }
        const { ret_code, ret_msg } = e.data;

        const errMsg = _global.__inverse_error_code_transition__?.(ret_code);

        if (
          ret_code === 50002 &&
          url.indexOf('/oauth/v1/private/authorize') < 0
        ) {
          reject(e);
          return;
        } else if (ret_code === 40029) {
          reject(e);
          return;
        }
        if (ret_code) {
          reject(e);
        } else {
          reject({ ret_code: -200, ret_msg: e, poz: 3 });
        }
      });
  });
};

fetchData.get = <T>(url: string, options?: any) => {
  // options?.time = 5 * 1000;

  return fetchData<T>(url, {
    ...options,
    method: 'GET',
  });
};

fetchData.post = <T>(url: string, options?: any) =>
  fetchData<T>(url, {
    ...options,
    method: 'POST',
  });

fetchData.put = (url: string, options?: any) =>
  fetchData(url, {
    ...options,
    method: 'PUT',
  });

fetchData.delete = (url: string, options?: any) =>
  fetchData(url, {
    ...options,
    method: 'DELETE',
  });

export const clearFetchCache = (
  type:
    | 'userProfile'
    | 'memberInfo'
    | 'permission_v2'
    | 'profile_v2'
    | 'user-tag',
) => {
  // 默认长时间缓存接口
  const cacheLongTimeFetchList = {
    userProfile: '/v2/private/user/profile',
    memberInfo: '/user/private/member/info',
    permission_v2: '/register/permission_v2',
    profile_v2: '/user/private/profile-v2',
    'user-tag': '/user/private/user-tag',
    'regulation-info': '/compliance/v1/wall/regulation-info',
  };

  const params = {
    url: `${API2_HOST}` + cacheLongTimeFetchList[type],
    method: 'get',
  };
  UniRequest?.cache?.clearOneCache(JSON.stringify(params));
};

export default fetchData;

/**
 *
 * @returns
 * /v2/private/user/profile
 * /user/private/profile-v2
 * /user/private/list/sub-members
 * /user/private/member/info
 * /user/private/total/sub-balance
 * /api/exchange-rate
 * /api/currencies
 * /user/private/apply/count
 * /api/newList
 * /user/private/user-tag
 * /fiat/otc/configuration/user/notice-config/get
 * /cht/asset/page/por/queryHisPorInfo
 */
